export default "__VITE_ASSET__Cqc$qYns__"